"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Logo = props => /*#__PURE__*/_react.default.createElement("svg", _extends({
  height: 50,
  viewBox: "0 0 1200 322.6",
  xmlSpace: "preserve"
}, props), /*#__PURE__*/_react.default.createElement("style", null, '.st0{fill: #85ccd3}' + '.st1{fill: #1b939e}' + '.st2,.st4{stroke: #000; stroke-width: 1.7498; stroke-miterlimit: 10}' + '.st4{stroke-width: 1.2967}' + '.st5{fill: #fff}' + '.st6,.st8{fill: none; stroke: #000; stroke-width: 3.3286; stroke-miterlimit: 10}' + '.st8{fill: #fff; stroke-width: 2.2191}'), /*#__PURE__*/_react.default.createElement("path", {
  className: "st0",
  d: "M420.5 121.1l15.8 12.9c4.6 3.9 7.1 7 7.5 12.9v45.8c0 5.8-4.6 10.4-10.4 10.4-5.9 0-10.6-4.6-10.6-10.4v-10.3l-21-19.5v29.8c0 5.8-4.7 10.4-10.5 10.4s-10.6-4.6-10.6-10.4V147c.5-5.9 3.3-9.1 7.7-12.9l15.5-12.9c6.1-4.9 10.6-5.2 16.6-.1zm2.3 40.4v-22h-21v22h21zM475.4 181.8V192c0 5.9-4.4 10.8-10.3 10.8-5.8 0-10.6-4.8-10.6-10.8v-56.2c0-9.8 8.1-17.9 17.9-17.9h16.1c4.8 0 9 1.7 12.5 5l11.6 11.6c7.6 7.3 6.3 25.2-1.1 32.3l-10.5 10c-3.5 3.5-7.6 5.1-12.5 5.1h-13.1zm20.3-21.1V139l-20.1-.2v21.9h20.1zM617.2 181.8V192c0 5.9-4.4 10.8-10.3 10.8-5.8 0-10.6-4.8-10.6-10.8v-56.2c0-9.8 8.1-17.9 17.9-17.9h16.1c4.8 0 9 1.7 12.5 5l11.6 11.6c7.6 7.3 6.3 25.2-1.1 32.3l-10.5 10c-3.5 3.5-7.6 5.1-12.5 5.1h-13.1zm20.3-21.1V139l-20.1-.2v21.9h20.1zM666 184.6v-56.5c0-5.7 5-10.4 10.6-10.4 6 0 10.8 4.7 10.8 10.4v53.7c10.6 0 7.6-.2 18.1-.2 13.9 0 13.9 21.3 0 21.3h-21.2c-9.9 0-18.3-8.2-18.3-18.3zM761.9 121.1l15.8 12.9c4.6 3.9 7.1 7 7.5 12.9v45.8c0 5.8-4.6 10.4-10.4 10.4-5.9 0-10.6-4.6-10.6-10.4v-10.3l-21-19.5v29.8c0 5.8-4.7 10.4-10.5 10.4s-10.6-4.6-10.6-10.4V147c.5-5.9 3.3-9.1 7.7-12.9l15.5-12.9c6.1-4.9 10.6-5.2 16.6-.1zm2.3 40.4v-22h-21v22h21zM835.9 117.7c13.7 0 13.7 21 0 21h-9.1v53.6c0 14.3-21.2 14.3-21.2 0v-53.6h-9.1c-13.8 0-13.8-21 0-21h39.4zM873.6 138.9v14h19c5.7 0 10.5 4.7 10.5 10.5 0 5.7-4.8 10.6-10.8 10.6h-18.7v18.5c0 13.8-21.2 13.8-21.2 0v-57c0-9.9 8-17.9 17.8-17.9h27c5.9 0 10.6 4.7 10.6 10.4 0 5.8-5 10.8-10.6 10.8h-23.6zM932 118.1h24.2c9.6 0 17.9 7.9 17.9 17.9v48.6c0 8.7-8.3 17.9-17.3 17.9h-25.3c-9 0-17.9-9.2-17.9-17.9V136c0-10.5 8.7-17.9 18.4-17.9zm20.9 21.2h-18.1v42.3h18.1v-42.3zM1034 168.1c7.5 4.6 10.2 10.4 10.2 18v6.2c0 5.8-4.7 10.5-10.3 10.5-5.9 0-10.4-5-10.4-10.5v-5.9l-20.7-25.2v31.1c0 5.8-4.6 10.5-10.4 10.5-5.9 0-10.6-4.7-10.6-10.5v-63.7c0-5.9 4.7-10.6 10.6-10.6h23.6c5 0 9.1 1.8 12.7 5.2l10.3 9.9c3.6 3.6 5.7 7.9 5.7 13.1v4.7c-.1 8.2-4 13.8-10.7 17.2zm-31.3-29.1v20.3h20.7V139h-20.7zM1088.6 121.2l9.2 9.8 9.2-9.8c5.1-5.3 12.3-5.3 17.1 0l12.3 12.8c3.7 4.2 6.9 6.9 7.5 12.8v46.1c0 13.7-21.3 13.7-21.3 0v-53.6h-14.2v53.6c0 14-21.2 14-21.2 0v-53.6h-13.9v53.6c0 13.7-21.3 13.7-21.3 0v-46.1c.2-5.9 3.6-8.6 7.5-12.8l12.3-12.8c4.8-5.3 12.1-5.3 16.8 0zM525.2 153.8c0-13.8 21.2-13.8 21.2-.1v39.1c0 13.8-21.2 13.7-21.2 0v-39zM546 139.5v-21.7l-20.1-.2v21.9z"
}), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("circle", {
  className: "st0",
  cx: 182.2,
  cy: 161.3,
  r: 136.7
}), /*#__PURE__*/_react.default.createElement("ellipse", {
  className: "st1",
  cx: 218.6,
  cy: 198,
  rx: 16.7,
  ry: 4.5
}), /*#__PURE__*/_react.default.createElement("ellipse", {
  className: "st1",
  cx: 246,
  cy: 221.4,
  rx: 16.7,
  ry: 4.5
}), /*#__PURE__*/_react.default.createElement("ellipse", {
  className: "st1",
  cx: 277.7,
  cy: 209.4,
  rx: 16.7,
  ry: 4.5
}), /*#__PURE__*/_react.default.createElement("ellipse", {
  className: "st1",
  cx: 254.1,
  cy: 196.9,
  rx: 16.7,
  ry: 4.5
}), /*#__PURE__*/_react.default.createElement("path", {
  className: "st2",
  d: "M241 211.4c2.8 0 6.3 3.4 6.3 7.5s-3.1 4-7.8 4c-4.7 0-10 0-10-4 4.3-2.8 7.1-7.5 11.5-7.5z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M248.3 188.1c2.5 0 5.6 3.2 5.6 6.9s-2.8 3.7-7 3.7-8.9 0-8.9-3.7c3.9-2.6 6.4-6.9 10.3-6.9z",
  stroke: "#000",
  strokeWidth: 1.592,
  strokeMiterlimit: 10
}), /*#__PURE__*/_react.default.createElement("path", {
  className: "st2",
  d: "M273 200c2.8 0 6.3 3.4 6.3 7.5s-3.1 4-7.8 4c-4.7 0-10 0-10-4 4.3-2.8 7.2-7.5 11.5-7.5z"
}), /*#__PURE__*/_react.default.createElement("path", {
  className: "st4",
  d: "M211.6 190.4c2.1 0 4.6 2.5 4.6 5.6s-2.3 3-5.8 3-7.4 1.2-7.4-1.8c3.3-2.1 5.4-6.8 8.6-6.8z"
}), /*#__PURE__*/_react.default.createElement("ellipse", {
  className: "st1",
  cx: 145.5,
  cy: 197,
  rx: 16.7,
  ry: 4.5
}), /*#__PURE__*/_react.default.createElement("path", {
  className: "st4",
  d: "M152.5 189.5c-2.1 0-4.6 2.5-4.6 5.6s2.3 3 5.8 3 7.4 1.2 7.4-1.8c-3.3-2.1-5.4-6.8-8.6-6.8z"
}), /*#__PURE__*/_react.default.createElement("path", {
  className: "st6",
  d: "M202.4 149.3l35.9-20 .6 65.2 6.7 1.3"
}), /*#__PURE__*/_react.default.createElement("path", {
  className: "st6",
  d: "M202.4 149.3l51.2-7.5 9 67.9"
}), /*#__PURE__*/_react.default.createElement("path", {
  className: "st6",
  d: "M200.8 158.8l14.9 3.6-10.9 32.5 6.3-.2"
}), /*#__PURE__*/_react.default.createElement("path", {
  className: "st6",
  d: "M202.4 149.3l29.4 7.7-1.4 62.4 6.2.8"
}), /*#__PURE__*/_react.default.createElement("ellipse", {
  className: "st1",
  cx: 118.3,
  cy: 221.4,
  rx: 16.7,
  ry: 4.5
}), /*#__PURE__*/_react.default.createElement("ellipse", {
  className: "st1",
  cx: 86.6,
  cy: 209.4,
  rx: 16.7,
  ry: 4.5
}), /*#__PURE__*/_react.default.createElement("ellipse", {
  className: "st1",
  cx: 110.1,
  cy: 196,
  rx: 16.7,
  ry: 4.5
}), /*#__PURE__*/_react.default.createElement("path", {
  className: "st2",
  d: "M123.4 211.4c-2.8 0-6.3 3.4-6.3 7.5s3.1 4 7.8 4 10 0 10-4c-4.3-2.8-7.2-7.5-11.5-7.5zM114.4 186.8c-2.8 0-6.3 3.4-6.3 7.5s3.1 4 7.8 4c4.7 0 10 0 10-4-4.4-2.8-7.2-7.5-11.5-7.5zM91.3 200c-2.8 0-6.3 3.4-6.3 7.5s3.1 4 7.8 4c4.7 0 10 0 10-4-4.3-2.8-7.1-7.5-11.5-7.5z"
}), /*#__PURE__*/_react.default.createElement("path", {
  className: "st6",
  d: "M161.9 149.3l-35.8-20-.7 65.2-6.6 1.3"
}), /*#__PURE__*/_react.default.createElement("path", {
  className: "st6",
  d: "M161.9 149.3l-51.2-7.5-9 67.9"
}), /*#__PURE__*/_react.default.createElement("path", {
  className: "st6",
  d: "M163.5 158.8l-14.9 3.6 10.9 32.5-5.5 2.4"
}), /*#__PURE__*/_react.default.createElement("path", {
  className: "st6",
  d: "M161.9 149.3l-29.3 7.7 1.3 62.4-6.2.8"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M202.8 124.5s14.2.8 14.2 14.6c0 13.8-10.3 25.3-29.8 27.8-18.7 2.4-36.5-6.8-36.5-28.9s20.5-18.4 20.5-18.4",
  fill: "#3caab5",
  stroke: "#000",
  strokeWidth: 2.458,
  strokeMiterlimit: 10
}), /*#__PURE__*/_react.default.createElement("ellipse", {
  className: "st8",
  cx: 201.7,
  cy: 122,
  rx: 16.6,
  ry: 17.2
}), /*#__PURE__*/_react.default.createElement("circle", {
  cx: 203.3,
  cy: 122.9,
  r: 7.6
}), /*#__PURE__*/_react.default.createElement("circle", {
  className: "st5",
  cx: 201.5,
  cy: 121.5,
  r: 2
}), /*#__PURE__*/_react.default.createElement("ellipse", {
  className: "st8",
  cx: 170.5,
  cy: 118.4,
  rx: 21,
  ry: 21.7
}), /*#__PURE__*/_react.default.createElement("circle", {
  cx: 172.2,
  cy: 119.6,
  r: 9.6
}), /*#__PURE__*/_react.default.createElement("ellipse", {
  transform: "matrix(.9984 -.05734 .05734 .9984 -6.46 10.35)",
  className: "st5",
  cx: 177.1,
  cy: 117.8,
  rx: 2.5,
  ry: 2.5
})));

var _default = Logo;
exports.default = _default;